import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Linkedin } from 'lucide-react';
import { clinicInfo } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-[#000053] text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_wellness-hub-468/artifacts/m2yep3lc_Polar%20Logo.png" 
              alt="Polar iHealth" 
              className="h-10 w-auto mb-4"
            />
            <p className="text-gray-300 text-sm mb-4">
              {clinicInfo.tagline}
            </p>
            {clinicInfo.acceptingNewPatients && (
              <div className="inline-block bg-[#006D73] text-white text-xs font-semibold px-3 py-1 rounded-full">
                Accepting New Patients
              </div>
            )}
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/family-practice" className="text-gray-300 hover:text-[#006D73] transition-colors text-sm">Family Practice</Link></li>
              <li><Link to="/pharmacy" className="text-gray-300 hover:text-[#006D73] transition-colors text-sm">Pharmacy</Link></li>
              <li><Link to="/rehab-services" className="text-gray-300 hover:text-[#006D73] transition-colors text-sm">Rehab Services</Link></li>
              <li><Link to="/team" className="text-gray-300 hover:text-[#006D73] transition-colors text-sm">Our Team</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-[#006D73] transition-colors text-sm">Contact</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Phone className="h-4 w-4 mt-1 text-[#006D73] flex-shrink-0" />
                <a href={`tel:${clinicInfo.phone}`} className="text-gray-300 hover:text-[#006D73] transition-colors text-sm">
                  {clinicInfo.phone}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="h-4 w-4 mt-1 text-[#006D73] flex-shrink-0" />
                <a href={`mailto:${clinicInfo.email}`} className="text-gray-300 hover:text-[#006D73] transition-colors text-sm">
                  {clinicInfo.email}
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-4 w-4 mt-1 text-[#006D73] flex-shrink-0" />
                <span className="text-gray-300 text-sm">
                  {clinicInfo.address}
                </span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Hours</h3>
            <ul className="space-y-2">
              <li className="flex justify-between text-sm">
                <span className="text-gray-300">Monday - Thursday:</span>
                <span className="text-white font-medium">{clinicInfo.hours.monday}</span>
              </li>
              <li className="flex justify-between text-sm">
                <span className="text-gray-300">Friday:</span>
                <span className="text-white font-medium">{clinicInfo.hours.friday}</span>
              </li>
              <li className="flex justify-between text-sm">
                <span className="text-gray-300">Saturday:</span>
                <span className="text-white font-medium">{clinicInfo.hours.saturday}</span>
              </li>
              <li className="flex justify-between text-sm">
                <span className="text-gray-300">Sunday:</span>
                <span className="text-white font-medium">{clinicInfo.hours.sunday}</span>
              </li>
            </ul>
            <div className="mt-6">
              <h4 className="text-sm font-semibold mb-3">Follow Us</h4>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-300 hover:text-[#006D73] transition-colors">
                  <Facebook className="h-5 w-5" />
                </a>
                <a href="#" className="text-gray-300 hover:text-[#006D73] transition-colors">
                  <Instagram className="h-5 w-5" />
                </a>
                <a href="#" className="text-gray-300 hover:text-[#006D73] transition-colors">
                  <Linkedin className="h-5 w-5" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 mt-8 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Polari Health. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;